/**
 * Hydrates the theme's native rating badge (rendered by snippets/product-rating.liquid
 * with klaviyo_sync: true) using the grouped-product rating that Klaviyo's own
 * star-rating widget computes client-side. Shopify's native review metafield is not
 * updated by Klaviyo's product grouping, so this mirrors Klaviyo's already-rendered,
 * hidden widget instead of relying on that metafield.
 */
(function () {
  function computeStarStates(ratingValue, max) {
    var decimal = ratingValue - Math.floor(ratingValue);
    var ratingDecimal = 0;
    if (decimal >= 0.3 && decimal <= 0.7) ratingDecimal = 0.5;
    else if (decimal > 0.7) ratingDecimal = 1;

    var states = [];
    var used = false;
    for (var i = 1; i <= max; i++) {
      if (i <= ratingValue) {
        states.push('full');
      } else if (!used) {
        states.push(ratingDecimal === 0.5 ? 'half' : ratingDecimal === 1 ? 'full' : 'empty');
        used = true;
      } else {
        states.push('empty');
      }
    }
    return states;
  }

  function starSvg(state, color) {
    if (state === 'full') {
      return '<svg aria-hidden="true" focusable="false" width="12" class="icon icon-star-rating" viewBox="0 0 12 11"><path d="M6 0v8.635L2.292 11 3.48 6.87 0 4.202l4.443-.187L6 0Zm0 0v8.635L9.708 11 8.52 6.87 12 4.202l-4.443-.187L6 0Z" fill="' + color + '"/></svg>';
    }
    if (state === 'half') {
      return '<svg aria-hidden="true" focusable="false" width="12" class="icon icon-star-rating-half" viewBox="0 0 12 11"><path d="M6 0v8.635L2.292 11 3.48 6.87 0 4.202l4.443-.187L6 0Z" fill="' + color + '"/><path d="M6 0v8.635L9.708 11 8.52 6.87 12 4.202l-4.443-.187L6 0Z" fill-opacity="0.4" fill="' + color + '"/></svg>';
    }
    return '<svg aria-hidden="true" focusable="false" width="12" class="icon icon-star-rating-empty" viewBox="0 0 12 11"><path d="M6 0v8.635L2.292 11 3.48 6.87 0 4.202l4.443-.187L6 0Zm0 0v8.635L9.708 11 8.52 6.87 12 4.202l-4.443-.187L6 0Z" fill-opacity="0.4" fill="' + color + '"/></svg>';
  }

  function parseAriaLabel(text) {
    if (!text) return null;
    var m = text.match(/^([\d.]+)\s*stars?,\s*(\d+)\s*ratings?/i);
    if (!m) return null;
    return { value: parseFloat(m[1]), count: parseInt(m[2], 10) };
  }

  function hydrate(badge, data, max) {
    var starsWrap = badge.querySelector('.rating-badge__stars');
    var countEl = badge.querySelector('.smallcaps');
    if (!starsWrap) return;

    var color = 'currentColor';
    var existingFill = starsWrap.querySelector('path[fill]');
    if (existingFill) color = existingFill.getAttribute('fill');

    var states = computeStarStates(data.value, max);
    starsWrap.innerHTML = states
      .map(function (s) {
        return starSvg(s, color);
      })
      .join('');

    if (countEl) countEl.textContent = '(' + data.count + ')';

    var klBtn = document.querySelector('.kl_reviews__star_rating_widget');
    var ariaText = klBtn ? klBtn.getAttribute('aria-label') : null;
    if (ariaText) {
      badge.setAttribute('title', ariaText);
      starsWrap.setAttribute('aria-label', ariaText);
    }

    badge.removeAttribute('hidden');
  }

  function init() {
    var badge = document.querySelector('[data-klaviyo-rating-badge]');
    if (!badge) return;

    var max = parseInt(badge.getAttribute('data-rating-max'), 10) || 5;

    var attempts = 0;
    var maxAttempts = 40; // ~8s at 200ms
    var timer = setInterval(function () {
      attempts++;
      var btn = document.querySelector('.kl_reviews__star_rating_widget');
      var ariaText = btn ? btn.getAttribute('aria-label') : null;
      var parsed = parseAriaLabel(ariaText);

      if (parsed && parsed.count > 0) {
        clearInterval(timer);
        hydrate(badge, parsed, max);
      } else if (attempts >= maxAttempts) {
        clearInterval(timer);
      }
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
